import JSSHA from "jssha";

export function sha224(input: string | Record<string, unknown>) {
  const shaObject = new JSSHA("SHA-224", "TEXT");
  shaObject.update(typeof input === "string" ? input : JSON.stringify(input));

  return shaObject.getHash("HEX");
}
